// Dynamic Focus Outline for Accessibility
// This script ensures the focus indicator meets WCAG 2.1 criteria (2.4.7 Focus Visible & 1.4.11 Non-text Contrast)
document.addEventListener("DOMContentLoaded", function() {

// Direct console solution for dynamic focus outline
(() => {
// --------STEP 1: Get the current background color of the promo bar--------
const promoBar = document.querySelector('.promo-bar');
if (!promoBar) {
console.error('No .promo-bar found');
return;
}

// Get computed background color
const bgColor = window.getComputedStyle(promoBar).backgroundColor;
console.log('Detected background color:', bgColor);

// --------STEP 2: Convert RGB background to HEX for calculations--------
function rgbToHex(rgb) {
// Handle edge cases
if (!rgb || rgb === 'transparent' || rgb === 'rgba(0, 0, 0, 0)') {
  return '#282828'; // Default fallback
}

// Extract RGB values
const rgbValues = rgb.match(/\d+/g);
if (!rgbValues || rgbValues.length < 3) {
  return '#282828'; // Default fallback
}

// Convert to hex
return '#' + rgbValues.slice(0, 3).map(x => {
  const hex = parseInt(x).toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}).join('');
}

const bgHex = rgbToHex(bgColor);
console.log('Background hex:', bgHex);

// --------STEP 3: Calculate contrast for various colors--------
function hexToRgb(hex) {
const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
return result ? {
  r: parseInt(result[1], 16),
  g: parseInt(result[2], 16),
  b: parseInt(result[3], 16)
} : null;
}

function luminance(hex) {
const rgb = hexToRgb(hex);
const a = [rgb.r, rgb.g, rgb.b].map(v => {
  v /= 255;
  return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
});
return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function contrast(hex1, hex2) {
const lum1 = luminance(hex1);
const lum2 = luminance(hex2);
const brightest = Math.max(lum1, lum2);
const darkest = Math.min(lum1, lum2);
return (brightest + 0.05) / (darkest + 0.05);
}

// --------STEP 4: Find best contrast color (minimum 3:1 ratio)--------
const candidateColors = [
'#FFFFFF', // White
'#000000', // Black
'#FF0000', // Red
'#00FF00', // Green
'#0000FF', // Blue
'#FFFF00', // Yellow
'#00FFFF', // Cyan
'#FF00FF'  // Magenta
];

let bestColor = '#FFFFFF';
let bestContrast = 0;

for (const color of candidateColors) {
const contrastRatio = contrast(bgHex, color);
console.log(`Contrast with ${color}: ${contrastRatio.toFixed(2)}`);

if (contrastRatio >= 3 && contrastRatio > bestContrast) {
  bestColor = color;
  bestContrast = contrastRatio;
}
}

console.log(`Selected outline color: ${bestColor} (contrast ratio: ${bestContrast.toFixed(2)})`);

// --------STEP 5: Apply the style with the best contrast color--------
const style = document.createElement('style');
style.id = 'dynamic-focus-outline';
style.innerHTML = `
@media screen and (min-width: 1024px) {
  a.UsableNetAssistive {
    color: ${bestColor} !important;
  }
  a.UsableNetAssistive:focus:not(.disableUsableNetAssistive) {
    outline: 2px solid ${bestColor} !important;
    outline-offset: 2px !important;
    opacity: 1 !important;
    color: ${bestColor} !important;
    visibility: visible !important;
  }
}
`;

// Remove old style if it exists
const oldStyle = document.getElementById('dynamic-focus-outline');
if (oldStyle) oldStyle.remove();

// Add new style
document.head.appendChild(style);

console.log('✅ Dynamic focus outline applied successfully');
})();
});